import { useAuth } from "@/lib/auth";

/**
 * Superusuario BNT (Fase 1+) — fuente única: GET /auth/me → is_platform_designer.
 * No inferir permisos en frontend (sin email designer_ui_access ni ALLOW_LICENSE_GENERATION).
 */
export function isPlatformDesignerUser(user) {
  return Boolean(user?.is_platform_designer);
}

export function usePlatformDesigner() {
  const { user } = useAuth();
  return isPlatformDesignerUser(user);
}
